export const ERROR_TYPES = {
  ERROR_FETCHING_IPFS: Symbol('Error fetching ipfs content'),
  ERROR_UNKNOWN_METADATA_TYPE: Symbol('Unknown evidence metadata type'),
}
